export default __webpack_public_path__ + "static/media/hero-bcg-2.9b0cb083.jpg";